import type { ReactNode, RefObject } from "react";
import logo from "../../assets/urmate-logo.webp";
import { ThemeToggle } from "../shell/ThemeToggle.js";
import { Avatar } from "../ui/Avatar.js";

/**
 * Powloka widoku recenzenta: sam naglowek (logo, "ConvoLens", nieklikalny znacznik "Recenzja: <etykieta>", przelacznik
 * motywu) i kolumna tresci. Bez bocznego menu, hamburgera, wylogowania i profilu: recenzent nie ma konta, a jedyna rzecz,
 * ktora moze zrobic, to przejrzec rozmowy z linku.
 *
 * Uzywa tych samych klas naglowka co powloka aplikacji (shell.css) i NIE dotyka wspolnych komponentow powloki. Co sie
 * rozni (brak odsuniecia o sidebar, logo przy lewej krawedzi, motyw widoczny takze na telefonie), jest w
 * styles/views/recenzja.css pod klasa .rec-header / .rec-main.
 *
 * Zadnej informacji o kosztach, modelach ani dostawcach: ta powloka ich po prostu nie zna.
 */
export function PowlokaRecenzji({
  etykieta,
  refGlowny,
  children,
}: {
  /** Dla kogo link (z panelu administratora); null, dopoki nie wiadomo. */
  etykieta: string | null;
  /**
   * Ref na <main>: uklad (UkladRecenzji) przenosi tam fokus po zmianie trasy, jak powloka aplikacji. Bez niego (strona
   * dla nieprawidlowego adresu) <main> jest zwyklym kontenerem.
   */
  refGlowny?: RefObject<HTMLElement | null>;
  children: ReactNode;
}): React.JSX.Element {
  return (
    <>
      <header className="app-header rec-header">
        <div className="header-left">
          <img className="brand" src={logo} alt="urmate.ai" />
          <span className="brand-name">ConvoLens</span>
        </div>
        <div className="header-right">
          <span className={`rec-chip${etykieta ? "" : " rec-chip--bez-awatara"}`}>
            {etykieta && <Avatar nazwa={etykieta} rozmiar="s" />}
            <span className="rec-chip__tekst">{etykieta ? `Recenzja: ${etykieta}` : "Recenzja"}</span>
          </span>
          <ThemeToggle wariant="pasek" />
        </div>
      </header>

      {/* Ta sama warstwa wygaszania co w powloce aplikacji (L-3a); bez sidebara siega do lewej krawedzi. */}
      <div className="scroll-fade rec-scroll-fade" aria-hidden="true" />

      {/* tabIndex=-1: <main> jest tylko celem PROGRAMOWEGO fokusu po zmianie trasy, nie wchodzi do kolejnosci Tab. */}
      <main className="app-main rec-main" ref={refGlowny} tabIndex={-1}>
        <div className="rec-content">{children}</div>
      </main>
    </>
  );
}
